export default {"src":"/_next/static/media/our-partners-img-seven.62d1fa61.svg","height":25,"width":150};